import {useState} from 'react';
import {TwoFactorChallengePage} from '@common/auth/ui/two-factor/two-factor-challenge-page';
import {LoginPage} from '@app/auth/login-page';

// CUSTOM(albaniantheatre): same as @common/auth/ui/login-page-wrapper, but
// pointed at the app's Turnstile-enabled login page.
export function LoginPageWrapper() {
  const [isTwoFactor, setIsTwoFactor] = useState(false);
  if (isTwoFactor) {
    return <TwoFactorChallengePage />;
  }
  return <LoginPage onTwoFactorChallenge={() => setIsTwoFactor(true)} />;
}
